import { render } from "./TopTagPage.vue?vue&type=template&id=4ccdbd50"
import script from "./TopTagPage.vue?vue&type=script&lang=js"
export * from "./TopTagPage.vue?vue&type=script&lang=js"
script.render = render

export default script